<span class="mat-option-text">
  <ng-content></ng-content>
</span>
